'use es6';

import { useSelector } from 'react-redux';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { getHasTheme } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getIsPublicContent } from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
import { injectOptimizationsSubMiddleware } from 'ContentEditorUI/js/lib/externalOptimizerHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncLayoutStylesSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'LayoutStylesSidebarContainer' */'ContentEditorUI/containers/layoutStyles/LayoutStylesSidebarContainer'));
const AsyncEditModuleSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'EditModuleSidebarContainer', webpackPrefetch: true */'ContentEditorUI/containers/EditModuleSidebarContainer'));
const AsyncTreeViewModuleListContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'TreeViewModuleListContainer' */'ContentEditorUI/components/sidebar/list/treeView/TreeViewModuleListContainer'));
const AsyncBaymaxPageDesignSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'BaymaxPageDesignSidebarContainer' */'page-editor-ui/containers/BaymaxPageDesignSidebarContainer'));
const AysncExternalOptimizerContainer = makeAsyncComponent(() => {
  const componentPromise = import( /* webpackChunkName: 'ExternalOptimizerContainer' */'ContentEditorUI/containers/ExternalOptimizerContainer');

  // Also dynamically setup middleware needed for the optimizer components
  injectOptimizationsSubMiddleware(import( /* webpackChunkName: 'optimizationsSubMiddleware' */'content-intel-editor-optimize-panel/utils/optimizationsSubMiddleware')).catch(error => {
    console.error('Error injecting OptimizationsSubMiddleware', error);
  });
  return componentPromise;
});
const PageSidebarPanelContainer = ({
  panelName,
  selectedRowOrColumn,
  selectedModuleInTree,
  selectedModuleName,
  editSidebarActiveTab,
  selectedField
}) => {
  const hasTheme = useSelector(getHasTheme);
  const contentId = useSelector(getContentModelId);
  const isPublicContent = useSelector(getIsPublicContent);
  if (!panelName) {
    return null;
  } else if (panelName === SIDEBAR_PANELS.addWidget) {
    // Add sidebar panel has an iframe an is handled elsewhere
    return null;
  } else if (panelName === SIDEBAR_PANELS.preview) {
    // Preview modal is handled elsewhere (but it still a "sidebar panel" in the code from pre-Baymax logic)
    return null;
  } else if (panelName === SIDEBAR_PANELS.widgetList) {
    return /*#__PURE__*/_jsx(AsyncTreeViewModuleListContainer, {
      allowBodyStyling: true
    });
  } else if (panelName === SIDEBAR_PANELS.edit) {
    // If this is a D&D area thing
    if (selectedRowOrColumn) {
      // And the thing is a row or column, but not a module
      if (selectedRowOrColumn.isRow() || selectedRowOrColumn.isCell() && !selectedRowOrColumn.isModule()) {
        return /*#__PURE__*/_jsx(AsyncLayoutStylesSidebarContainer, {
          showDeviceToggle: true,
          node: selectedRowOrColumn
        });
      }
    }
    return /*#__PURE__*/_jsx(AsyncEditModuleSidebarContainer, {
      contentId: contentId,
      isPublicContent: isPublicContent,
      showDeviceToggle: true,
      selectedModuleInTree: selectedModuleInTree,
      selectedModuleName: selectedModuleName,
      editSidebarActiveTab: editSidebarActiveTab,
      selectedField: selectedField
    });
  } else if (panelName === SIDEBAR_PANELS.design) {
    return hasTheme ? /*#__PURE__*/_jsx(AsyncBaymaxPageDesignSidebarContainer, {}) : /*#__PURE__*/_jsx(AsyncEditModuleSidebarContainer, {
      isBodyStyle: true,
      showDeviceToggle: true,
      selectedModuleInTree: selectedModuleInTree,
      selectedModuleName: selectedModuleName,
      editSidebarActiveTab: editSidebarActiveTab,
      selectedField: selectedField
    });
  } else if (panelName === SIDEBAR_PANELS.optimizer) {
    return /*#__PURE__*/_jsx(AysncExternalOptimizerContainer, {
      contentId: contentId
    });
  }
  throw new Error(`Unknown panel: ${panelName}`);
};
export default PageSidebarPanelContainer;